var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPollDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 2 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15176_5321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2179 21.4203C12.0762 21.4203 11.9333 21.4203 11.7948 21.4203L8.40396 23.313C7.08396 22.869 5.85962 22.1798 4.79522 21.2817L4.78253 17.473C4.70741 17.3545 4.63653 17.235 4.57093 17.1123L1.19918 15.192C0.933606 13.8487 0.933606 12.4664 1.19918 11.1231L4.56776 9.20817C4.63653 9.0865 4.70741 8.96589 4.77935 8.8474L4.79628 5.03871C5.85971 4.138 7.08374 3.4463 8.40396 3L11.7895 4.89271C11.9312 4.89271 12.0741 4.89271 12.2127 4.89271L15.5982 3C16.9182 3.44402 18.1425 4.13318 19.2069 5.0313L19.2196 8.83999C19.2947 8.95849 19.3656 9.07804 19.4312 9.20076L22.8008 11.1199C23.0664 12.4632 23.0664 13.8456 22.8008 15.1889L19.4322 17.1038C19.3635 17.2255 19.2926 17.3461 19.2206 17.4646L19.2037 21.2733C18.141 22.1741 16.9177 22.8662 15.5982 23.313L12.2179 21.4203Z",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5996 17.2737V11.2737H13.3996",
    stroke: "#42296E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7998 17.2737V13.6737H10.5998",
    stroke: "#42296E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2004 8.87366H13.4004V17.2737H16.2004V8.87366Z",
    stroke: "#42296E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17.2737H7",
    stroke: "#42296E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56982 10.0737H10.0314",
    stroke: "#42296E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80029 8.84302V11.3046",
    stroke: "#42296E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15176_5321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollDetails);
export default __webpack_public_path__ + "static/media/poll_details.7c32faae887b790cc06c0fa0098be455.svg";
export { ForwardRef as ReactComponent };